// extracted by mini-css-extract-plugin
export var dropdownIcon = "_i6-6";
export var imgContainer = "_i6-3";
export var menuIcon = "_i6-5";
export var pillWrapper = "_i6-2";
export var pillsContainer = "_i6-1";
export var subscriptionCard = "_i6-0";
export var subscriptionLogo = "_i6-4";